import GearMark from "@/components/GearMark";

export default function SolutionMotif({ variant = "amplify" }) {
  const gid = `grid-${variant}`;
  return (
    <div className="blueprint-grid relative h-full min-h-[300px] w-full overflow-hidden bg-parchment">
      <GearMark
        size={96}
        className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 animate-spin-slower drop-shadow-[0_16px_36px_rgba(214,53,10,0.3)]"
      />
      <svg viewBox="0 0 480 320" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice">
        <defs>
          <pattern id={gid} width="30" height="30" patternUnits="userSpaceOnUse">
            <path d="M30 0H0V30" fill="none" stroke="#E2DDD4" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="480" height="320" fill={`url(#${gid})`} opacity="0.7" />

        {variant === "amplify" ? (
          <g>
            <path d="M310 160 A70 70 0 0 0 293.6 115" fill="none" stroke="#D6350A" strokeWidth="1.6" strokeLinecap="round" />
            <path d="M335 160 A95 95 0 0 0 312.8 98.9" fill="none" stroke="#D6350A" strokeWidth="1.4" strokeLinecap="round" opacity="0.7" />
            <path d="M360 160 A120 120 0 0 0 331.9 82.9" fill="none" stroke="#A9C7DD" strokeWidth="1.4" strokeLinecap="round" opacity="0.9" />
            <circle r="3" fill="#D6350A">
              <animateMotion dur="4.5s" repeatCount="indefinite" path="M310 160 A70 70 0 0 0 293.6 115" />
            </circle>

            <g stroke="#D6350A" strokeWidth="1.3" fill="#FBEAE2">
              <rect x="62" y="248" width="18" height="30" rx="2" />
              <rect x="94" y="230" width="18" height="48" rx="2" fill="#F7D8C8" />
              <rect x="126" y="208" width="18" height="70" rx="2" fill="#F0C2AB" />
            </g>
            <polyline points="62,236 96,214 128,190 160,168" fill="none" stroke="#A9C7DD" strokeWidth="1.4" strokeDasharray="3 5" />
            <circle cx="160" cy="168" r="3.5" fill="#38BDF8" />
          </g>
        ) : (
          <g>
            <circle cx="240" cy="160" r="112" fill="none" stroke="#A9C7DD" strokeWidth="1.4" strokeDasharray="5 8" opacity="0.9" />
            <circle cx="240" cy="160" r="112" fill="none" stroke="#D6350A" strokeWidth="1.6" strokeLinecap="round" strokeDasharray="70 634">
              <animateTransform attributeName="transform" type="rotate" from="0 240 160" to="360 240 160" dur="9s" repeatCount="indefinite" />
            </circle>
            <circle cx="240" cy="160" r="140" fill="none" stroke="#E8E4DD" strokeWidth="1.2" />

            <g stroke="#A9C7DD" strokeWidth="1.3" strokeDasharray="4 6">
              <line x1="30" y1="70" x2="150" y2="70" />
              <line x1="330" y1="250" x2="450" y2="250" />
              <line x1="30" y1="250" x2="110" y2="250" />
            </g>
            <circle r="3" fill="#38BDF8">
              <animateMotion dur="4s" repeatCount="indefinite" path="M30 70 L150 70" />
            </circle>
            <circle r="3" fill="#D6350A">
              <animateMotion dur="5s" begin="1.2s" repeatCount="indefinite" path="M330 250 L450 250" />
            </circle>
            <polyline points="288,52 296,60 288,68" fill="none" stroke="#D6350A" strokeWidth="1.6" strokeLinecap="round" />
          </g>
        )}
      </svg>
    </div>
  );
}
